import React from 'react';
import PaymentConfirmationSection from 'components/RegistrationNew/PaymentConfirmationSection';

const PaymentConfirmationNew = ({ ...props }) => {
  return (
    <div>
      <PaymentConfirmationSection {...props} />
    </div>
  );
};

export default PaymentConfirmationNew;
